import { render, staticRenderFns } from "./riskManage.vue?vue&type=template&id=73549e2a&scoped=true"
import script from "./riskManage.vue?vue&type=script&lang=js"
export * from "./riskManage.vue?vue&type=script&lang=js"
import style0 from "./riskManage.vue?vue&type=style&index=0&id=73549e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73549e2a",
  null
  
)

export default component.exports